import { render, staticRenderFns } from "./gonetwork1.vue?vue&type=template&id=ffa78952&scoped=true&"
import script from "./gonetwork1.vue?vue&type=script&lang=js&"
export * from "./gonetwork1.vue?vue&type=script&lang=js&"
import style0 from "./gonetwork1.vue?vue&type=style&index=0&id=ffa78952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa78952",
  null
  
)

export default component.exports